import { __read, __spreadArray, __values } from "tslib";
import { cloneDeep, uniq, sortBy } from 'lodash';
import { productListCategorySort } from '../constants/productSort';
var productGroupSortArray = [
    'Boy',
    'Girl',
    'Baby Boy',
    'Baby Girl',
    'Outerwear',
    'Unisex',
    'Basic',
    'Accessories',
    'Swimwear',
    'Marketing',
];
export var FilterHelper = {
    isInitialFilterReady: isInitialFilterReady,
    filterIsEmpty: filterIsEmpty,
    resultByFilter: resultByFilter,
    hydrateSeasons: hydrateSeasons,
    hydrateProductGroups: hydrateProductGroups,
    hydrateDeliveryWindows: hydrateDeliveryWindows,
    hydrateProductCategories: hydrateProductCategories,
    hydrateSustainability: hydrateSustainability,
    hydrateCollections: hydrateCollections,
    changeActiveFilters: changeActiveFilters,
    hydrateProductCategoriesByCollectionSort: hydrateProductCategoriesByCollectionSort,
};
function hydrateSeasons(styles) {
    return uniq(styles.map(function (style) { return style.seasonCode; }));
}
function hydrateProductGroups(styles) {
    var productGroups = uniq(styles.map(function (style) { return style.productGroup; }));
    return sortBy(productGroups, function (item) {
        return productGroupSortArray.indexOf(item);
    });
}
function hydrateDeliveryWindows(styles) {
    return uniq(styles.map(function (style) { return style.deliveryWindow.originalWindow; }));
}
function hydrateProductCategories(styles) {
    return uniq(styles.map(function (style) { return style.productCategory; })).sort();
}
function hydrateProductCategoriesByCollectionSort(styles, collectionName) {
    var categories = uniq(styles.map(function (style) { return style.productCategory; }));
    if (!productListCategorySort[collectionName]) {
        return categories;
    }
    var sorted = [];
    var keysNotInSort = categories.filter(function (cat) { return productListCategorySort[collectionName].indexOf(cat) === -1 && cat.toLowerCase() !== 'marketing'; });
    var keysInSort = categories.filter(function (cat) { return productListCategorySort[collectionName].indexOf(cat) !== -1 && cat.toLowerCase() !== 'marketing'; });
    keysInSort = sortBy(keysInSort, function (item) {
        return productListCategorySort[collectionName].indexOf(item);
    });
    sorted = __spreadArray(__spreadArray([], __read(keysInSort), false), __read(keysNotInSort), false);
    if (categories.indexOf('Marketing') !== 1) {
        sorted.push('Marketing');
    }
    return sorted;
}
function hydrateCollections(styles) {
    return uniq(styles.map(function (style) { return style.collectionName; }));
}
function hydrateSustainability(styles) {
    var sustainabilityFilters = [];
    if (styles.filter(function (style) { return style.gots !== ''; }).length) {
        sustainabilityFilters.push('gots');
    }
    if (styles.filter(function (style) { return style.ocsno !== ''; }).length) {
        sustainabilityFilters.push('ocs_100');
    }
    if (styles.filter(function (style) { return style.grsno !== ''; }).length) {
        sustainabilityFilters.push('grs');
    }
    if (styles.filter(function (style) { return style.ocsblended !== ''; }).length) {
        sustainabilityFilters.push('ocs_blended');
    }
    if (styles.filter(function (style) { return style.oekotex !== ''; }).length) {
        sustainabilityFilters.push('oekoTex');
    }
    if (styles.filter(function (style) { return !!style.recycled; }).length) {
        sustainabilityFilters.push('recycled');
    }
    if (styles.filter(function (style) { return !!style.organic; }).length) {
        sustainabilityFilters.push('organic');
    }
    if (styles.filter(function (style) { return !!style.ecovero; }).length) {
        sustainabilityFilters.push('ecovero');
    }
    return sustainabilityFilters;
}
function isInitialFilterReady(filter) {
    return filter && filter.activeFilters && (filter.activeFilters.seasons.length ||
        filter.activeFilters.collections.length ||
        filter.activeFilters.productGroups.length ||
        filter.activeFilters.deliveryWindows.length ||
        filter.activeFilters.productCategories.length ||
        filter.activeFilters.minimumAvailable ||
        (filter.activeFilters.visiblePrices && filter.activeFilters.visiblePrices.length) ||
        (filter.activeFilters.sustainability && filter.activeFilters.sustainability.length));
}
function filterIsEmpty(filter) {
    return filter.activeFilters.collections.length === 0 &&
        filter.activeFilters.deliveryWindows.length === 0 &&
        filter.activeFilters.productGroups.length === 0 &&
        filter.activeFilters.productCategories.length === 0 &&
        filter.activeFilters.seasons.length === 0;
}
function resultByFilter(filter, styles) {
    var e_1, _a, e_2, _b, e_3, _c;
    var newStyles = cloneDeep(styles);
    // if everything is empty, the initial filter isn't ready yet
    if (!isInitialFilterReady(filter)) {
        return styles;
    }
    // seasons
    if (filter.activeFilters.seasons.length) {
        newStyles = newStyles.filter(function (style) { return filter.activeFilters.seasons.indexOf(style.seasonCode) !== -1; });
    }
    // collections 
    if (filter.activeFilters.collections.length) {
        newStyles = newStyles.filter(function (style) { return filter.activeFilters.collections.indexOf(style.collectionName) !== -1; });
    }
    // deliveryWindows 
    if (filter.activeFilters.deliveryWindows.length) {
        newStyles = newStyles.filter(function (style) { return style.deliveryWindow &&
            filter.activeFilters.deliveryWindows.indexOf(style.deliveryWindow.originalWindow) !== -1; });
    }
    // productGroups
    if (filter.activeFilters.productGroups.length) {
        var chunks = [];
        var _loop_1 = function (group) {
            var chunk = newStyles.filter(function (style) { return style.subCategories
                .map(function (name) { return name.toLowerCase(); })
                .indexOf(group.toLowerCase()) !== -1; });
            chunks = __spreadArray(__spreadArray([], __read(chunks), false), __read(chunk), false);
        };
        try {
            for (var _d = __values(filter.activeFilters.productGroups), _e = _d.next(); !_e.done; _e = _d.next()) {
                var group = _e.value;
                _loop_1(group);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var original = newStyles.filter(function (style) { return filter.activeFilters.productGroups.indexOf(style.productGroup) !== -1; });
        newStyles = uniq(__spreadArray(__spreadArray([], __read(original), false), __read(chunks), false));
    }
    // productCategories
    if (filter.activeFilters.productCategories.length) {
        newStyles = newStyles.filter(function (style) { return filter.activeFilters.productCategories.indexOf(style.productCategory) !== -1; });
    }
    // Sustainabilty.
    if (filter.activeFilters.sustainability && filter.activeFilters.sustainability.length) {
        var cloned = __spreadArray([], __read(newStyles), false);
        var sustainabilityItems = {
            gots: [],
            ocs_100: [],
            grs: [],
            ocs_blended: [],
            oekoTex: [],
            recycled: [],
            organic: [],
            ecovero: []
        };
        try {
            for (var _f = __values(filter.activeFilters.sustainability), _g = _f.next(); !_g.done; _g = _f.next()) {
                var item = _g.value;
                switch (item) {
                    case 'gots':
                        var gots = cloned.filter(function (style) { return style.gots !== ''; });
                        sustainabilityItems.gots = gots;
                        break;
                    case 'oekoTex':
                        var oekoTex = cloned.filter(function (style) { return style.oekotex !== ''; });
                        sustainabilityItems.oekoTex = oekoTex;
                        break;
                    case 'recycled':
                        var recycled = cloned.filter(function (style) { return !!style.recycled; });
                        sustainabilityItems.recycled = recycled;
                        break;
                    case 'ocs_100':
                        console.log('hydrate ocs_100');
                        var ocs_100 = cloned.filter(function (style) { return style.ocsno !== ''; });
                        sustainabilityItems.ocs_100 = ocs_100;
                        break;
                    case 'grs':
                        console.log('hydrate grs');
                        var grs = cloned.filter(function (style) { return style.grsno !== ''; });
                        sustainabilityItems.grs = grs;
                        break;
                    case 'ocs_blended':
                        var ocs_blended = cloned.filter(function (style) { return style.ocsblended !== ''; });
                        sustainabilityItems.ocs_blended = ocs_blended;
                        break;
                    case 'organic':
                        var organic = cloned.filter(function (style) { return !!style.organic; });
                        sustainabilityItems.organic = organic;
                        break;
                    case 'ecovero':
                        var ecovero = cloned.filter(function (style) { return !!style.ecovero; });
                        sustainabilityItems.ecovero = ecovero;
                        break;
                }
                newStyles = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(sustainabilityItems.gots), false), __read(sustainabilityItems.oekoTex), false), __read(sustainabilityItems.recycled), false), __read(sustainabilityItems.organic), false), __read(sustainabilityItems.ecovero), false), __read(sustainabilityItems.ocs_100), false), __read(sustainabilityItems.ocs_blended), false), __read(sustainabilityItems.grs), false);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_2) throw e_2.error; }
        }
        console.dir(sustainabilityItems);
    }
    if (filter.activeFilters.visiblePrices && filter.activeFilters.visiblePrices.length) {
        var cloned = __spreadArray([], __read(newStyles), false);
        var priceItems = {
            'Show missing WS': [],
            'Show missing RRP': [],
        };
        try {
            for (var _h = __values(filter.activeFilters.visiblePrices), _j = _h.next(); !_j.done; _j = _h.next()) {
                var item = _j.value;
                switch (item) {
                    case 'Show missing WS':
                        // whp
                        var missingWhp = cloned.filter(function (style) { return style.whp === 0; });
                        priceItems['Show missing WS'] = missingWhp;
                        break;
                    case 'Show missing RRP':
                        // whp
                        var missingRRP = cloned.filter(function (style) { return style.whp === 0; });
                        priceItems['Show missing RRP'] = missingRRP;
                        break;
                    default:
                        break;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
            }
            finally { if (e_3) throw e_3.error; }
        }
        newStyles = __spreadArray(__spreadArray([], __read(priceItems['Show missing WS']), false), __read(priceItems['Show missing RRP']), false);
    }
    newStyles = newStyles.filter(function (style) { return style.totalDisp >= filter.activeFilters.minimumAvailable; });
    return newStyles;
}
function changeActiveFilters(filter, filterType, filterValue, isActive) {
    var newFilter = cloneDeep(filter);
    if (!newFilter)
        return newFilter;
    switch (filterType) {
        case 'deliveryWindows':
            if (isActive) {
                newFilter.activeFilters.deliveryWindows.push(filterValue);
            }
            else {
                var filterTypeIndex = newFilter.activeFilters.deliveryWindows.indexOf(filterValue);
                newFilter.activeFilters.deliveryWindows.splice(filterTypeIndex, 1);
            }
            break;
        case 'productGroups':
            if (isActive) {
                newFilter.activeFilters.productGroups.push(filterValue);
            }
            else {
                var filterTypeIndex = newFilter.activeFilters.productGroups.indexOf(filterValue);
                newFilter.activeFilters.productGroups.splice(filterTypeIndex, 1);
            }
            break;
        case 'productCategories':
            if (isActive) {
                newFilter.activeFilters.productCategories.push(filterValue);
            }
            else {
                var filterTypeIndex = newFilter.activeFilters.productCategories.indexOf(filterValue);
                newFilter.activeFilters.productCategories.splice(filterTypeIndex, 1);
            }
            break;
        case 'topCollections':
            if (isActive) {
                newFilter.activeFilters.collections.push(filterValue);
            }
            else {
                var filterTypeIndex = newFilter.activeFilters.collections.indexOf(filterValue);
                newFilter.activeFilters.collections.splice(filterTypeIndex, 1);
            }
            break;
        case 'sustainability':
            if (isActive && newFilter.activeFilters.sustainability) {
                newFilter.activeFilters.sustainability.push(filterValue);
            }
            else {
                if (newFilter.activeFilters.sustainability) {
                    var filterTypeIndex = newFilter.activeFilters.sustainability.indexOf(filterValue);
                    newFilter.activeFilters.sustainability.splice(filterTypeIndex, 1);
                }
            }
            break;
        case 'visiblePrices':
            if (isActive && newFilter.activeFilters.visiblePrices) {
                newFilter.activeFilters.visiblePrices.push(filterValue);
            }
            else {
                if (newFilter.activeFilters.visiblePrices) {
                    var filterTypeIndex = newFilter.activeFilters.visiblePrices.indexOf(filterValue);
                    newFilter.activeFilters.visiblePrices.splice(filterTypeIndex, 1);
                }
            }
            break;
    }
    return newFilter;
}
//# sourceMappingURL=FilterHelper.js.map